export class CompetencyData{
    competencyId:number;
    competencyName:string;
    subCompetencyId:number;
    subCompetencyName:string;
    subCompetencyLeader:string;
}